import { useEffect } from "react";
import Services from "./Services";
import Referenser from "./Referenser";
import Kontakt from "./Kontakt";
import About from "./About";



export default function Home() {


  useEffect(() => {
    //document.title = "Mureri & Eldstäder Söderhamn";

  }, []);

  return (
    <>
    <article id="start">
      <section className="title"  id="home_title">
        <h1>Mureri &amp; eldstäder i Söderhamn</h1>
        <img src="/images/logo.png" alt="Mureri & Eldstäder Söderhamn" className="logo" />
        <span className="title">För en trygg & värmande framtid</span>

      </section>
      <section>
        <p>
          Välkommen till Mureri & Eldstäder i Söderhamn AB - din lokala expert på allt inom eldstäder från kaminer, vedspisar, kakelugnar, bakugnar, renovering av rökkanaler till mur- och putsarbeten.
        </p>
        <p>
          Mureri & Eldstäder brinner för traditionellt hantverk och gedigen kvalitet. Vi arbetar med både traditionella och moderna lösningar för att skapa trygga och hållbara resultat och sätter alltid kunden i fokus för att förverkliga sina drömmar.
        </p>
        <p>
          Vi arbetar med privatpersoner, företag och föreningar. Vi utgår från Söderhamn och utför arbeten i hela Hälsingland, bland annat i Bollnäs och Hudiksvall. Vi tar även uppdrag i Gästrikland, med Hälsingland som vårt huvudsakliga arbetsområde.
        </p>
        <p>
          <em>Vi strävar alltid efter att leverera kvalitet, säkerhet, noggrannhet och ett hållbart resultat.</em>
        </p>
      </section>
    </article>
    <Services/>
    <Referenser/>
    <Kontakt/>
    <About/>

    </>
  )
}